import { find } from 'lodash';
import { CondictionColumnsConfig } from './shared/condictions-columns.config.service';
import {
  Forma,
  Control,
  BaseControl,
  AsociacionTareaForma,
  SubForma,
  Option,
  ConfirmComponent,
  Static,
  CondicionColumnaSelector,
  OptionsColumns,
  TipoControl,
  EstructuraEspecifica,
  ValoresEspecificos,
  ColumnaMaestra,
  ColumnsTableModalSelect
} from '@app/shared';
import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { CondictionsColumnsFormsService } from './shared/condictions-columns.form.service';
import { CreationDynamicComponentDataService } from '../../shared/creation-dynamic-component.data.service';
import { CondictionColumnsDataService } from './shared/condictions-columns.data.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-condictions-columns',
  templateUrl: './condictions-columns.component.html',
  styleUrls: ['./condictions-columns.component.scss'],
  providers: [
    CondictionsColumnsFormsService,
    CreationDynamicComponentDataService,
    CondictionColumnsDataService
  ]
})
export class CondictionsColumnsComponent implements OnInit, OnDestroy {
  // Entrada de las columnas
  @Input() set columnsMaster (condictions: OptionsColumns[]) {
    this._columnsMaster = condictions;
  }
  // Entrada de las condiciones
  @Input() form: Forma;
// Contiene el formulario del control
  @Input() formulario: Control[] = [];
  // Contiene el control a condicionar
  @Input() control: Control;
  // Mensaje de la accion a realizar en el formulario de condicion
  actionForm = '';
  // Forma temporalmete seleccionada
  formSelected = '';
  // Formulario temporalmete seleccionado
  formularioSelected = '';
  // Formulario temporalmete seleccionado
  fieldSelected = '';
  // Operador condicional seleccionado temporalmente
  selectedSiEs = '';
  // Index del registro de condicion seleccionado
  indexSelected = -1;
  // Define cuando se muestra el formulario para agregar o modificar la condicion
  formCondiction = false;
  // Define cuando se modifica la condicion o se agrega una nueva
  condictionEdit = false;
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  // Condiciones
  condictionsField: CondicionColumnaSelector[] = [];
  // Contiene las asociaciones de las formas
  formsAssociations: AsociacionTareaForma[] = [];
  // Contiene los formularios de la forma actual
  formularios: SubForma[] = [];
  // Opciones de formas
  formOptions: Option[] = [];
  // Opciones de Formularios
  formulariosOpctions: Option[] = [];
  // Opciones de Campos
  fieldOptions: Option[] = [];
  // Formas asociadas
  associatedFormsConsulted: Forma[] = [];
  // Contiene las consultas de las columnas de las maestras
  acomulateColumns: Array<{
    name: string,
    columns: ValoresEspecificos[],
  }> = [];
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Condicion seleccionada
  condictionSelect: CondicionColumnaSelector;
  // Condicion seleccionada
  condictionTemp: CondicionColumnaSelector;
  // Contiene las opciones del formulario de condiciones
  options: any = {};
  // Contiene los templates para el formulario
  templates = {};
  // Contiene la informacion de las diferentes columnas de la maestra seleccionada
  private _columnsMaster: OptionsColumns[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelectOnly') private ngSelectTplOnly: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelectMultiple') private ngSelectTplMultiple: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Salida de las condiciones agregadas
  @Output() condictions: EventEmitter<CondicionColumnaSelector[]> = new EventEmitter();

  constructor(
    private ccfs: CondictionsColumnsFormsService,
    private cdcds: CreationDynamicComponentDataService,
    private ccds: CondictionColumnsDataService
  ) { }

  ngOnInit() {
    this.templates = {
      only: this.ngSelectTplOnly,
      multiple: this.ngSelectTplMultiple
    };
    // Obteniendo las condiciones de el control a condicionar
    if (this.control) {
      if (
        this.control.validaciones &&
        this.control.validaciones.condiciones_columnas &&
        this.control.validaciones.condiciones_columnas.length
      ) {
        this.condictionsField = Static.copyObjet(this.control.validaciones.condiciones_columnas);
      }
    }
    // opciones de la forma
    if (this.form) {
      if (this.form.alias) {
        if (this.form.alias) {
          this.formOptions.push({
            key: this.form.alias,
            value: this.form.alias
          });
        }
      }
      // Obtiene los formularios de la forma actual
      this.form.sub_formas.forEach(subForma => this.formularios.push(subForma));
    }
    if (this.form.asociaciones && this.form.asociaciones.length) {
      this.form.asociaciones.forEach(association => {
        this.formsAssociations.push(association);
        this.formOptions.push({
          key: association.aliasAsociacion,
          value: association.aliasAsociacion
        });
      });
    }
    // Configurando tabla
    const configTable = new CondictionColumnsConfig();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });
    this.loadingCondictions();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  trigger(callback: any, ...args: any[]) {
    return callback(...args);
  }

  get columnsMaster() {
    return this._columnsMaster;
  }

  /**
   * Controla las acciones en la tabla de condiciones
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof CondictionsColumnsComponent
   */
  defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    if (action !== 'delete') {
      this.options = {
        forms: this.formOptions,
        columnsMaster: this.columnsMaster
      };
    }
    switch (action) {
      case 'add':
        this.formCondiction = true;
        this.condictionEdit = false;
        this.actionForm = 'Agregar';
        this.controls = this.ccfs.getFormCondiction(this.templates, this.options);
        break;
      case 'update':
        this.formCondiction = true;
        this.condictionEdit = true;
        this.actionForm = 'Modificar';
        this.condictionSelect = data;
        this.indexSelected = this.condictionSelect['index'];
        this.formSelected = this.condictionSelect.forma;
        this.formularioSelected = this.condictionSelect.formulario;
        this.fieldSelected = this.condictionSelect.campo;
        this.condictionTemp = data;
        this.getFormulariosForm(false);
        break;
      case 'delete':
        this.condictionSelect = data;
        this.indexSelected = this.condictionSelect.index;
        this.confirm.new({
          question: '¿Realmente desea eliminar la condición?',
          labelConfirm: 'Sí',
          labelDecline: 'No'
        }).then(resp => {
          if (resp) {
            this.deleteCondictions();
          }
        });
        break;
    }
  }

  /**
   * Controla los diferentes cambios en el formulario para mostrar la informacion correcta
   *
   * @param {*} data
   * @memberof CondictionsColumnsComponent
   */
  changeForm(data: any) {
    if (data.change) {
      delete this.condictionTemp;
      this.condictionTemp = {
        forma: data.change.cboForm,
        formulario: data.change.cboFormulario,
        campo: data.change.cboField,
        siEs: data.change.cboSiEs,
        valor: data.change.txtValor,
        fechaActual: data.change.chFechaActual,
        columnas: data.change.cboColumns,
        placeholder: data.change.txtPlaceholder,
        nombre_columnas: '',
        columnas_selector_modal: [],
        index: this.indexSelected,
      };
      if (this.formSelected !== data.change.cboForm) {
        this.formSelected = data.change.cboForm;
        this.condictionTemp.forma = data.change.cboForm;
        this.condictionTemp.formulario = null;
        this.condictionTemp.campo = null;
        this.formularioSelected = '';
        this.getFormulariosForm();
      } else if (this.formularioSelected !== data.change.cboFormulario) {
        this.formularioSelected = data.change.cboFormulario;
        this.condictionTemp.formulario = data.change.cboFormulario;
        this.condictionTemp.campo = null;
        this.getFieldForm();
      } else if (this.fieldSelected !== data.change.cboField) {
        this.fieldSelected = data.change.cboField;
        this.refreshFormCondiction();
      }

      if (this.selectedSiEs !== data.change.cboSiEs) {
        this.selectedSiEs = data.change.cboSiEs;
        if (this.condictionTemp.siEs === 'Vacio') {
          this.condictionTemp.valor = null;
        }
        this.refreshFormCondiction(true);
      }
    }
  }

  /**
   * Cierra el formulario de edicion o creacion de la condicion
   *
   * @memberof CondictionsColumnsComponent
   */
  closeFormCondiction() {
    this.formCondiction = false;
    this.formSelected = '';
    this.formularioSelected = '';
    this.selectedSiEs = '';
    this.formulariosOpctions = [];
    this.fieldOptions = [];
    this.options = {};
    this.controls = [];
    if (this.condictionEdit) {
      this.indexSelected = -1;
      this.condictionEdit = false;
      delete this.condictionSelect;
    }
  }

  /**
   * Guarda o edita el registro de condicion
   *
   * @param {*} data
   * @memberof ConditionsComponent
   */
  sended(data: any) {
    const moment = require('moment');
    // Validar si el valor es una fecha
    let date = false;
    let nameColumns = '';
    if (data.txtValor && moment(new Date(data.txtValor)).isValid()) {
      date = true;
    } else if (data.chFechaActual) {
      date = true;
    }
    // Crear la nueva condicion
    const newCondiction: CondicionColumnaSelector = {
      forma: data.cboForm,
      formulario: data.cboFormulario,
      campo: data.cboField,
      siEs: data.cboSiEs,
      valor: data.txtValor,
      fechaActual: data.chFechaActual,
      columnas: data.cboColumns,
      placeholder: data.txtPlaceholder,
      columnas_selector_modal: [],
      nombre_columnas: ''
    };
    // Consultar el formulario de el campos seleccionado
    let form: SubForma;
    if (this.form.alias === this.formSelected) {
      form = find(this.form.sub_formas, {alias: this.formularioSelected});
    } else {
      const association = find(this.formsAssociations, {aliasAsociacion: this.formSelected});
      if (association) {
        const formcondictionalSeleted = find(this.associatedFormsConsulted, {id: association.idForma});
        if (formcondictionalSeleted) {
          form = find(formcondictionalSeleted.sub_formas, {alias: this.formularioSelected});
        }
      }
    }
    // Consulta el campo en el formulario encontrado
    let field: Control;
    if (form) {
      field = find(form.campos, {alias: this.fieldSelected});
    }
    // Genera el texto del valor a mostrar en la tabla dependiendo del tipo de campo
    if (field) {
      if (field.tipo_campo && field.tipo_campo.nombre === 'ngSelect') {
        newCondiction['textSelect'] = this.getValueNgSelect(field, data.txtValor);
      } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
        if (data.txtValor === 'true') {
          newCondiction['textSelect'] = 'Seleccionado';
        } else {
          newCondiction['textSelect'] = 'No seleccionado';
        }
      } else if (date && (data.txtValor instanceof Date || field.tipo_campo.nombre === 'date-time-picker')) {
        newCondiction['textSelect'] = this.getValueDate(field, data.txtValor, data.chFechaActual);
      }
    }
    // Genera el nombre en conjunto de las columnas seleccionadas para mostrar en la tabla
    if (newCondiction.columnas && newCondiction.columnas.length) {
      newCondiction.columnas.forEach((column, i) => {
        if (i > 0) {
          nameColumns += ' - ';
        }
        const col = find(this.columnsMaster, {value: column});
        if (col) {
          nameColumns += col.key;
        }
      });
    }
    newCondiction.nombre_columnas = nameColumns;
    // Genera la configuracion de las columnas para los selectores en modal de las columnas seleccionadas
    const columnsModalSelector: Array<ColumnsTableModalSelect> = [];
    newCondiction.columnas.forEach((col: string) => {
      const selectColumn = find(this.columnsMaster, {value: col});
      if (selectColumn) {
        let labelSelector = selectColumn.key.replace(':', '');
        if (selectColumn.column !== selectColumn.key) {
          labelSelector = selectColumn.column.replace(':', '') + ' - ' + selectColumn.key.replace(':', '');
        }
        const columSelector: ColumnsTableModalSelect = {
          key: selectColumn.value,
          label: labelSelector,
          type: selectColumn.type,
          category: selectColumn.category
        };
        columnsModalSelector.push(columSelector);
      }
    });
    newCondiction.columnas_selector_modal = columnsModalSelector;
    // Agrega o edita la condicion
    if (!this.condictionEdit) {
      this.condictionsField.push(newCondiction);
    } else {
      this.condictionsField[this.indexSelected] = newCondiction;
    }
    this.loadingCondictions();
    this.closeFormCondiction();
  }

  /**
   * Carga las condiciones para mostralas en la tabla
   *
   * @private
   * @memberof CondictionsColumnsComponent
   */
  private loadingCondictions() {
    this.condictionsField.map((condictions, index) => {
      condictions.index = index;
      if (!condictions['textSelect']) {
        condictions['value'] = condictions.valor;
      } else {
        condictions['value'] = condictions['textSelect'];
      }
    });
    this.sourceData = new LocalDataSource(this.condictionsField);
    this.condictions.emit(this.condictionsField);
    this.sourceData.refresh();
  }

  /**
   * Carga la lista de opciones para el campo de formularios con los formularios de la forma seleccionada
   *
   * @private
   * @param {boolean} [update=true]
   * @memberof CondictionsColumnsComponent
   */
  private async getFormulariosForm(update: boolean = true) {
    this.formulariosOpctions = [];
    this.fieldOptions = [];
    if (this.form.alias === this.formSelected) {
      this.form.sub_formas.forEach(subForma => {
        this.formulariosOpctions.push({
          key: subForma.alias,
          value: subForma.alias
        });
      });
      this.options['formFormularios'] = this.formulariosOpctions;
      if (update) {
        this.refreshFormCondiction();
      } else {
        this.getFieldForm();
      }
    } else {
      const association = find(this.formsAssociations, {aliasAsociacion: this.formSelected});
      if (association) {
        const formcondictionalSeleted = find(this.associatedFormsConsulted, {id: association.idForma});
        if (!formcondictionalSeleted) {
          this.cdcds.getForm(association.idForma).subscribe(form => {
            if (form) {
              this.associatedFormsConsulted.push(form);
              form.sub_formas.forEach(subForm => {
                if (subForm.alias && !subForm.tabla) {
                  this.formulariosOpctions.push({
                    key: subForm.alias,
                    value: subForm.alias,
                  });
                }
              });
            }
            this.options['formFormularios'] = this.formulariosOpctions;
            if (update) {
              this.refreshFormCondiction();
            } else {
              this.getFieldForm();
            }
          });
        } else {
          formcondictionalSeleted.sub_formas.forEach(subForm => {
            if (subForm.alias && !subForm.tabla) {
              this.formulariosOpctions.push({
                key: subForm.alias,
                value: subForm.alias,
              });
            }
          });
          this.options['formFormularios'] = this.formulariosOpctions;
          if (update) {
            this.refreshFormCondiction();
          } else {
            this.getFieldForm();
          }
        }
      } else {
        this.options['fields'] = this.fieldOptions;
        this.options['formFormularios'] = this.formulariosOpctions;
        if (update) {
          this.refreshFormCondiction();
        } else {
          this.getFieldForm();
        }
      }
    }
  }

  /**
   * Se encarga de consultar los campos del formulario inicial o condicionado seleccionado
   * genera las opciones a seleccionar de los campos y refresca el formulario de condicion
   *
   * @private
   * @memberof CondictionsColumnsComponent
   */
  private getFieldForm() {
    this.fieldOptions = [];
    // Consulta si el formulario seleccionado es de la forma actual
    let formulario = find(this.formularios, {alias: this.formularioSelected});
    if (!formulario || this.formSelected !== this.form.alias) {
      // consulta si la forma seleccionada se encuentra en las asociaciones
      const association = find(this.formsAssociations, {aliasAsociacion: this.formSelected});
      if (association) {
        // Consulta la estructura de la forma
        const form = find(this.associatedFormsConsulted, {id: association.idForma});
        if (form) {
          // Consulta el formulario seleccionado
          formulario = find(form.sub_formas, {alias: this.formularioSelected});
        }
      }
    }

    if (formulario) {
      formulario.campos.forEach(field => {
        if (field.alias) {
          this.fieldOptions.push({
            key: field.alias,
            value: field.alias,
          });
        }
      });
    }
    this.options['fields'] = this.fieldOptions;
    this.refreshFormCondiction();
  }

  /**
   * Refresca el formulario
   *
   * @private
   * @param {boolean} [skitType=false]
   * @memberof CondictionsColumnsComponent
   */
  private refreshFormCondiction(skitType: boolean = false) {
    let typeField: TipoControl;
    let typeDate: 'calendar' | 'timer' | 'dateTimer' = null;
    let field: Control;
    if (this.condictionTemp.campo) {
      // Consulta si el formulario seleccionado es de la forma actual
      let formulario = find(this.formularios, {alias: this.formularioSelected});
      if (!formulario) {
        // consulta si la forma seleccionada se encuentra en las asociaciones
        const association = find(this.formsAssociations, {aliasAsociacion: this.formSelected});
        if (association) {
          // Consulta la estructura de la forma
          const form = find(this.associatedFormsConsulted, {id: association.idForma});
          if (form) {
            // Consulta el formulario seleccionado
            formulario = find(form.sub_formas, {alias: this.formularioSelected});
          }
        }
      }
      if (formulario && this.condictionTemp.campo) {
        const ctr = find(formulario.campos, {alias: this.condictionTemp.campo});
        if (ctr) {
          field = ctr;
          typeField = ctr.tipo_campo;
          if (ctr.propiedades && ctr.propiedades['tipo']) {
            typeDate = ctr.propiedades['tipo'];
          }
        }
      }
    }
    if (!skitType && field) {
      if (typeField.nombre === 'ngSelect') {
        this.loadingOptionsControl(field);
      } else {
        if (field && typeField.nombre === 'date-time-picker') {
          if (typeDate && typeDate !== 'dateTimer') {
            this.options['tipo'] = typeDate;
          } else {
            delete this.options['tipo'];
          }
        }
        this.controls = this.ccfs.getFormCondiction(this.templates, this.options, this.condictionTemp, typeField);
      }
    } else {
      this.controls = this.ccfs.getFormCondiction(this.templates, this.options, this.condictionTemp, typeField);
    }
  }

  /**
   * Carga los datos de la maestra del select indicado
   *
   * @private
   * @param {Control} control
   * @memberof CondictionsColumnsComponent
   */
  private async loadingOptionsControl(control: Control) {
    if (
      control.tipo_campo.nombre === 'ngSelect' &&
      control.propiedades.tipo === 'TablaMaestra'
    ) {
      const columnsMaster: Option[] = [];
      let columns: ValoresEspecificos[];

      const colsMaster = find(this.acomulateColumns, {name: control.nombre_campo});
      if (!colsMaster) {
        const specificEstructure = this.getStructureColumnsSpecific(control);
        columns = await this.ccds.getColumnsSpecificMasterTable(specificEstructure);

        this.acomulateColumns.push({
          name: control.nombre_campo,
          columns: columns
        });
      } else {
        columns = colsMaster.columns;
      }

      columns.forEach(column => {
        let labelSelect = '';
        control.propiedades['columnas_seleccionadas'].forEach((col: number, index: any) => {
          if (index > 0) {
            labelSelect += ' / ';
          }
          if (column.valores[col]) {
            labelSelect += column.valores[col] ;
          } else {
            labelSelect += 'No aplica';
          }
        });
        columnsMaster.push({value: column.id, key: labelSelect});
      });
      this.options['optColumnMaster'] = columnsMaster;
      this.refreshFormCondiction(true);
    } else {
      delete this.options['optColumnMaster'];
      this.refreshFormCondiction(true);
    }
  }

  /**
   * Obtiene la estrutura de las columnas de la consulta a la maestra
   *
   * @private
   * @param {Control} control
   * @returns {EstructuraEspecifica}
   * @memberof CondictionsColumnsComponent
   */
  private getStructureColumnsSpecific(control: Control): EstructuraEspecifica {
    const specificEstructure: EstructuraEspecifica = {
      maestra: String(control.lista_maestra[0].id),
      columnas: [],
      dependencia: []
    };
    control.propiedades['columnas_seleccionadas'].forEach((col: string) => {
      const cols = col.split('_');
      const column = Number(cols[0]);
      if (cols.length === 1) {
        const structure = find(control.lista_maestra[0].estructura, {id: column});
        if (structure) {
          specificEstructure.columnas.push(column + ' ');
        }
      }
    });
    if (control.propiedades['columnas_seleccionadas'].length) {
      const blockColumns: Array<string[]> = [];
      if (control.propiedades['columnas_seleccionadas']) {
        let columnDependence = '';
        control.propiedades['columnas_seleccionadas'].forEach((col: string) => {
          const column = col.split('_');
          if (column.length > 1) {
            if (columnDependence !== column[0]) {
              columnDependence = column[0];
              const blockColumnsRecolector: Array<string> = [];
              control.propiedades['columnas_seleccionadas'].forEach((colDep: string) => {
                const columnsRef = colDep.split('_');
                if (columnsRef[0] === columnDependence) {
                  blockColumnsRecolector.push(colDep);
                }
              });
              blockColumns.push(blockColumnsRecolector);
            }
          }
        });
        blockColumns.forEach(columnsSeleted => {
          const history = this.loadingEstructureColumns(
            control.lista_maestra[0]['estructura'],
            columnsSeleted,
            Number(columnsSeleted[0].split('_')[0])
          );

          if (history) {
            specificEstructure.dependencia.push(history);
          }
        });
      }
    }
    return specificEstructure;
  }

  /**
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @private
   * @param {ColumnaMaestra[]} structure
   * @param {Array<string>} columns
   * @param {number} [idDependence=0]
   * @returns {EstructuraEspecifica}
   * @memberof CondictionsColumnsComponent
   */
  private loadingEstructureColumns(
    structure: ColumnaMaestra[],
    columns: Array<string>,
    idDependence: number = 0
  ): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const cls: Array<string> = [];
    specificEstructure = {
      maestra: null,
      columnas: [],
      dependencia: []
    };
    columns.forEach(el => {
      cls.push(el);
    });
    for (const field of structure) {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        if (idDependence !== 0 && idDependence !== field.id) {
          continue;
        }
        specificEstructure.maestra = field.id + ' ';
        cls.forEach((col: string, index: number) => {
          const  cols = col.split('_');
          const column = Number(cols[1]);
          if (cols.length === 2) {
            const dependenc = Number(cols[0]);
            if (typeof field.maestra_dependencia === 'object') {
              const columnField = find(field.maestra_dependencia.estructura, {id: column});
                if (dependenc === field.id) {

                if (columnField) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            }
          } else if (cols.length > 2) {
            const cl = cols.slice(1);
            cls[index] = '';
            cl.forEach((el: any, indexCol: number) => {
              cls[index] += el;

              if (indexCol < (cl.length - 1)) {
                cls[index] += '_';
              }

            });
          }
        });
        if (cls.length) {
          const newLevel = this.loadingEstructureColumns(field.maestra_dependencia['estructura'], cls);
          if (newLevel) {
            specificEstructure.dependencia.push(newLevel);
            break;
          }
        }
      }
    }
    if (specificEstructure.maestra && (specificEstructure.columnas.length || specificEstructure.dependencia.length)) {
      return specificEstructure;
    } else {
      return null;
    }
  }

  /**
   * Obtiene el texto de el valor seleccionado a comparar en la condicion cuando el campo es de tipo ngSelect
   *
   * @private
   * @param {Control} control
   * @param {number} value
   * @returns {string}
   * @memberof CondictionsColumnsComponent
   */
  private getValueNgSelect(control: Control, value: number): string {
    let valueResult = '';
    const rows = find(this.acomulateColumns, {name: control.nombre_campo});
    if (rows) {
      const valor = find(rows.columns, {id: value});
      let labelSelect = '';
      if (
        valor &&
        control.propiedades['columnas_seleccionadas'] &&
        control.propiedades['columnas_seleccionadas'].length
      ) {
        control.propiedades['columnas_seleccionadas'].forEach((col: string, index: any) => {
          if (index > 0) {
            labelSelect += ' / ';
          }
          if (valor.valores[col]) {
            labelSelect += valor.valores[col];
          } else {
            labelSelect += 'No aplica';
          }
        });
      }
      valueResult = labelSelect;
    }
    return valueResult;
  }

  /**
   * Obtiene el texto de el valor seleccionado a comparar en la condicion cuando el campo es de tipo date
   *
   * @private
   * @memberof CondictionsColumnsComponent
   */
  private getValueDate(control: Control, value: any, currentDate: boolean): string {
    const moment = require('moment');
    const dateValor: Date = currentDate ? null : new Date(value);
    let valueResult = '';
    if (
      control.propiedades &&
      control.propiedades['tipo']
    ) {
      if (moment(dateValor).isValid()) {
        dateValor.setSeconds(0, 0);
        switch (control.propiedades['tipo']) {
          case 'calendar':
            valueResult = dateValor.toLocaleDateString();
            break;
          case 'timer':
            value = dateValor.toLocaleTimeString();
            break;
          default:
            value = dateValor.toLocaleDateString() + ' ' + dateValor.toLocaleTimeString();
            break;
        }
      } else {
        if (currentDate) {
          value = 'Fecha actual';
        }
      }
    } else {
      if (moment(dateValor).isValid()) {
        dateValor.setSeconds(0, 0);
        value = dateValor.toLocaleDateString() + ' ' + dateValor.toLocaleTimeString();
      } else {
        if (currentDate) {
          value = 'Fecha actual';
        }
      }
    }
    return valueResult;
  }

  /**
   * Elimina el registro seleccionado de las condiciones
   *
   * @private
   * @memberof CondictionsColumnsComponent
   */
  private deleteCondictions() {
    this.condictionsField.splice(this.indexSelected, 1);
    this.loadingCondictions();
    this.closeFormCondiction();
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/condictions-columns/condictions-columns.component.ts